<template>
    <li class="dropdown-item nav-item w-100" :class="{ 'nested_aside_active': isActive()}">
        <router-link :to="{ path: link.path }" active-class="" 
        exact-active-class="" class="d-flex gap-2 align-items-center">
            
        
            <!-- <span v-html="link.icon"></span> -->
             <i :class="link.icon"></i>
            <h3 class="aside_item fs-16px">{{ Lang.get(`messages.sidebar.${link.label}`) }}</h3>
  
    </router-link>
        
    </li>
</template>


<script>

export default {
    name: "SidebarItemChild",
    props: {
        link: Object,
    },
    methods:{
        isActive() {
      return this.$route.path == this.link.path;
        }
    }
  
    // mounted(){
    //     this.$emit('mounted',this.$route.path==this.link.path)
    // },
}
</script>